import type { FiltersPopoverProps } from "./types-filters-popover";
import { useFiltersPopover } from "./use-filters-popover";
import { FiltersPopoverView } from "./view-filters-popover";

/**
 * Gatilho "Filtros" com contador e painel flutuante das listagens; o conteúdo é o `FilterPanel` do DS. O estado
 * do painel (`Root`) fica fora do `OverlayPanel` para sobreviver ao fechar e reabrir.
 */
export function FiltersPopover(props: FiltersPopoverProps) {
  const vm = useFiltersPopover(props);

  return <FiltersPopoverView {...vm} />;
}

export type { FiltersPopoverProps } from "./types-filters-popover";
